import { Component, computed, input, ViewEncapsulation } from '@angular/core';
import { UserIconComponent } from '@lb/components';
import { IMDDropDownOption } from '@melodic-ui/components/drop-down/drop-down.component';

@Component({
	selector: 'lrnr-user-drop-down-option',
	standalone: true,
	imports: [UserIconComponent],
	template: `
		<lb-user-icon [userID]="userID()"></lb-user-icon>
		<span>{{ option().label }}</span>
	`,
	styles: `
		lrnr-user-drop-down-option {
			display: flex;
			align-items: center;
			gap: var(--md-spacing-lg);
			margin-right: 15px;

			lb-user-icon {
				margin-top: -2px;
				width: 32px;
				height: 32px;

				div.user-initials {
					font-size: 13px;
				}
			}
		}
	`,
	encapsulation: ViewEncapsulation.None
})
export class UserDropDownOptionComponent {
	public option = input.required<IMDDropDownOption>();

	public userID = computed(() => this.option().value as number | undefined);
}
